var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "prePaidManage_block" },
    [
      _vm.loading
        ? _c("div", { staticClass: "card" }, [
            _c(
              "div",
              { staticClass: "card-body" },
              [
                _c("pulse-loader", {
                  staticClass: "text-center",
                  attrs: {
                    loading: _vm.loading,
                    color: _vm.$constants.LOADING_COLOR,
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.loading && _vm.displayOptions
        ? [
            _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "card-body" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-6" }, [
                    _c("p", [
                      _vm._v("Заявка: "),
                      _c("strong", [_vm._v(_vm._s(_vm.localOrder.id))]),
                      _vm._v(" ("),
                      _c("strong", [
                        _vm._v(_vm._s(_vm.localOrder.project_label)),
                      ]),
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.$AllCities[_vm.localOrder.city_id]
                              ?.short_name ?? _vm.localOrder.city_id
                          ) +
                          ")"
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v("Клиент: "),
                      _c("strong", [
                        _vm._v(_vm._s(_vm.localOrder.client_name)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v("Скидка: "),
                      _c("strong", [
                        _vm._v(_vm._s(_vm.localOrder.discount || 0)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v("Доставка: "),
                      _c("strong", [
                        _vm._v(_vm._s(_vm.localOrder.delivery_price || 0)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v("Общая сумма: "),
                      _c("strong", [_vm._v(_vm._s(_vm.localOrder.price))]),
                    ]),
                    _vm._v(" "),
                    _vm.localOrder.extra_options.post_track
                      ? _c("p", [
                          _vm._v("Трек номер: "),
                          _c("strong", [
                            _vm._v(
                              _vm._s(_vm.localOrder.extra_options.post_track)
                            ),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.localOrder.extra_options.email
                      ? _c("p", [
                          _vm._v("email: "),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.localOrder.extra_options.email)),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.historyEmail.length
                      ? _c(
                          "div",
                          [
                            _c("p", [_vm._v("Отправленные письма")]),
                            _vm._v(" "),
                            _vm._l(_vm.historyEmail, function (m) {
                              return _c("div", { staticClass: "flex" }, [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.printDate(m.created_at))),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "ml-2" },
                                  [
                                    _c(
                                      "v-popover",
                                      {
                                        attrs: {
                                          popoverClass:
                                            "popover_trace_letter_body",
                                          placement: "right",
                                          popoverInnerClass:
                                            "small_email_tarce_tooltip",
                                          trigger: "hover",
                                          delay: { show: 150, hide: 500 },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "icon-fa icon-fa-info info_fa",
                                        }),
                                        _vm._v(" "),
                                        _c("template", { slot: "popover" }, [
                                          _c("div", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                m.data.letter.body
                                              ),
                                            },
                                          }),
                                        ]),
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                ),
                              ])
                            }),
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.smsHistory.length
                      ? _c(
                          "div",
                          { staticClass: "mt-1" },
                          [
                            _c("p", [_vm._v("Отправленные SMS")]),
                            _vm._v(" "),
                            _vm._l(_vm.smsHistory, function (sms) {
                              return _c("div", { staticClass: "sms_history" }, [
                                _c("p", [
                                  _c("strong", [_vm._v("SMS:")]),
                                  _vm._v(" " + _vm._s(sms.sms_body)),
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _c("strong", [_vm._v("Телефон:")]),
                                  _vm._v(" " + _vm._s(sms.phone_number)),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  { staticClass: "text-muted text-right" },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.printDate(sms.created_at))
                                    ),
                                  ]
                                ),
                              ])
                            }),
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.localOrder.pay_method === 3
                      ? _c(
                          "div",
                          { staticClass: "alert alert-success mt-1 p-1" },
                          [
                            _c("p", [_vm._v("Оплата подтверждена")]),
                            _vm._v(" "),
                            _c("p", [
                              _c("strong", [_vm._v("комментарий:")]),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.localOrder.extra_options
                                      .pre_paid_comment
                                  )
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-6" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("p", [_vm._v("Карты для оплаты")]),
                      _vm._v(" "),
                      _c("input", {
                        attrs: { type: "hidden", id: "copy_text" },
                      }),
                      _vm._v(" "),
                      _c("table", { staticClass: "table table-sm mt-0" }, [
                        _c(
                          "tbody",
                          _vm._l(_vm.cardsForOrder, function (c, i) {
                            return _c("tr", [
                              _c("td", [_vm._v(_vm._s(i + 1))]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(_vm.cardTypes[c.type_id])),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "(" +
                                    _vm._s(c.record_id ?? c.id) +
                                    ") " +
                                    _vm._s(
                                      c.card_num ??
                                        _vm.prePaidCards[c.id]?.number
                                    ) +
                                    "\n                    "
                                ),
                                c.data?.payDetails?.id
                                  ? _c("div", [
                                      _vm._v(_vm._s(c.data.payDetails.id)),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                c?.data?.invoice
                                  ? _c("span", { staticClass: "fs-12" }, [
                                      _vm._v(_vm._s(c?.data?.invoice) + " "),
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn btn-outline-info btn-xs",
                                          attrs: { type: "button" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.copyText(
                                                c.data.invoice
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "icon-fa icon-fa-copy",
                                          }),
                                        ]
                                      ),
                                    ])
                                  : _vm._e(),
                              ]),
                              _vm._v(" "),
                              _c("td", [_c("strong", [_vm._v(_vm._s(c.sum))])]),
                              _vm._v(" "),
                              _c(
                                "td",
                                [
                                  _vm.cardsStatuses[c.status]
                                    ? [
                                        _c(
                                          "span",
                                          { staticClass: "badge badge-info" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.cardsStatuses[c.status]
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    : [
                                        _c("span", [
                                          _vm._v("Status: " + _vm._s(c.status)),
                                        ]),
                                      ],
                                  _vm._v(" "),
                                  c.status === 9
                                    ? _c("LoadingButton", {
                                        attrs: {
                                          title: "Проверить оплату",
                                          type: "button",
                                          loading: _vm.btnPaymentLoading,
                                          color: _vm.$constants.LOADING_COLOR,
                                          onClick: () => _vm.confirmPayment(),
                                          className:
                                            "btn btn-outline-info btn-xs",
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                [
                                  _vm.orderType === "selectedCard"
                                    ? [
                                        c.type_id === 1
                                          ? [
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn btn-xs btn-outline-success",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.getSMS(c.id)
                                                    },
                                                  },
                                                },
                                                [_vm._v("поиск оплаты")]
                                              ),
                                            ]
                                          : _vm._e(),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ])
                          }),
                          0
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.orderType === "selectedCard"
                      ? _c("div", [
                          _c(
                            "div",
                            {
                              staticClass: "flex justify-content-between mt-1",
                            },
                            [
                              _c(
                                "div",
                                [
                                  _vm.allowToRemoveCard()
                                    ? _c("LoadingButton", {
                                        attrs: {
                                          title: "удалить реквизиты",
                                          className:
                                            "btn btn-outline-warning btn-xs",
                                          onClick: () => _vm.rejectPrePaid(),
                                          loading: _vm.btnRejectLoading,
                                          color: _vm.$constants.WARNING_COLOR,
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", [
                                _vm.localOrder.status !== 3
                                  ? _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-outline-success btn-xs",
                                        attrs: { type: "button" },
                                        on: {
                                          click: () => (_vm.sendBlock = true),
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                    отправить уведомление клиенту\n                  "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    (_vm.pairedSMS && _vm.pairedSMS.length) ||
                    (_vm.localOrder.extra_options.payment_sms ?? []).length
                      ? _c("div", { staticClass: "mt-1" }, [
                          _c("p", [_vm._v("Привязанные SMS оплаты")]),
                          _vm._v(" "),
                          _c("table", { staticClass: "table table-sm mt-1" }, [
                            _c(
                              "tbody",
                              _vm._l(
                                [
                                  ..._vm.pairedSMS,
                                  ...(_vm.localOrder.extra_options
                                    .payment_sms ?? []),
                                ],
                                function (s) {
                                  return _c("tr", [
                                    _c("td", [
                                      _vm._v(_vm._s(s.id) + " "),
                                      s.card_id
                                        ? _c("span", [
                                            _vm._v(
                                              "(" + _vm._s(s.card_id) + ")"
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [_vm._v(_vm._s(s.sum))]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _c("p", [_vm._v(_vm._s(s.message))]),
                                      _vm._v(" "),
                                      _c("p", { staticClass: "text-muted" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.printDate(
                                              _vm.moment(s.date).add(3, "hours")
                                            )
                                          )
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      s.updated_at
                                        ? _c("p", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.printDate(s.updated_at)
                                              )
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      s.user_id
                                        ? _c(
                                            "p",
                                            { staticClass: "text-muted" },
                                            [
                                              _c("UserName", {
                                                attrs: { id: s.user_id },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      [
                                        _vm.allowToRemoveSMS(s)
                                          ? _c(
                                              "v-popover",
                                              {
                                                attrs: {
                                                  "auto-hide": true,
                                                  open: _vm
                                                    .openDeleteSMSTooltip[s.id],
                                                },
                                                on: {
                                                  hide: () =>
                                                    (_vm.openDeleteSMSTooltip[
                                                      s.id
                                                    ] = false),
                                                },
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn btn-outline-danger btn-xs",
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "icon-fa icon-fa-trash",
                                                    }),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "template",
                                                  { slot: "popover" },
                                                  [
                                                    _c("p", [
                                                      _vm._v(
                                                        "Действительно хотите удалить отвязать SMS?"
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "flex justify-content-between",
                                                      },
                                                      [
                                                        _c("LoadingButton", {
                                                          attrs: {
                                                            title:
                                                              "подтвердить",
                                                            className:
                                                              "btn btn-outline-danger btn-xs",
                                                            onClick: () =>
                                                              _vm.removeSMS(
                                                                s.id
                                                              ),
                                                            loading:
                                                              _vm
                                                                .btnRemoveSMSLoading[
                                                                s.id
                                                              ],
                                                            color:
                                                              _vm.$constants
                                                                .WARNING_COLOR,
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "btn btn-default btn-xs",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                _vm.openDeleteSMSTooltip[
                                                                  _vm.r.id
                                                                ] = false
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "отмена\n                          "
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              2
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ])
                                }
                              ),
                              0
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "mt-1 text-right" },
                            [
                              _c("LoadingButton", {
                                attrs: {
                                  title: "Заявка полностью оплачена",
                                  className: "btn btn-success btn-xs",
                                  onClick: () => _vm.savePrePaid(true),
                                  loading: _vm.btnLoading,
                                  color: _vm.$constants.SUCCESS_COLOR,
                                },
                              }),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ]),
                _vm._v(" "),
                _vm.orderType === "freeOrder"
                  ? _c(
                      "div",
                      { staticClass: "mt-1 flex justify-content-end" },
                      [
                        _c("div", [
                          _c("div", { staticClass: "alert alert-info" }, [
                            _c("p", [
                              _vm._v("Заявки суммуй до "),
                              _c("strong", [_vm._v(_vm._s(_vm.minOrderPrice))]),
                              _vm._v(
                                " оплачиваются только через сервис StreamPay"
                              ),
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v("Сегодня рекомендуем использовать "),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    _vm.getOddDay() ? "StreamPay" : "CoinCat"
                                  )
                                ),
                              ]),
                              _vm._v(" сервис\n                для оплаты"),
                            ]),
                          ]),
                          _vm._v(" "),
                          +_vm.cardsType === 3
                            ? _c("div", { staticClass: "mb-1" }, [
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.cardsForOrder[0].id,
                                        expression: "cardsForOrder[0].id",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    on: {
                                      change: function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.$set(
                                          _vm.cardsForOrder[0],
                                          "id",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "option",
                                      {
                                        attrs: {
                                          value: "0",
                                          selected: "",
                                          disabled: "",
                                        },
                                      },
                                      [_vm._v("Выберите карту")]
                                    ),
                                    _vm._v(" "),
                                    _vm._l(_vm.prePaidCards, function (c) {
                                      return _c(
                                        "option",
                                        { domProps: { value: c.id } },
                                        [
                                          _vm._v(_vm._s(c.number) + " "),
                                          c?.extra_options?.user?.short_name
                                            ? _c("span", [
                                                _vm._v(
                                                  "(" +
                                                    _vm._s(
                                                      c.extra_options.user
                                                        .short_name
                                                    ) +
                                                    ")"
                                                ),
                                              ])
                                            : _vm._e(),
                                        ]
                                      )
                                    }),
                                  ],
                                  2
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "flex" },
                            [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.cardsType,
                                      expression: "cardsType",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.cardsType = $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                  },
                                },
                                [
                                  _c("option", { attrs: { value: "3" } }, [
                                    _vm._v("Сбер"),
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "5" } }, [
                                    _vm._v("Перевод на крипту (coincat)"),
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "6" } }, [
                                    _vm._v("Перевод через SteamPay"),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c("LoadingButton", {
                                attrs: {
                                  title: "Добавить к заявке",
                                  className:
                                    "btn btn-outline-success btn-xs w-50",
                                  onClick: () => _vm.savePrePaid(),
                                  loading: _vm.btnLoading,
                                  color: _vm.$constants.SUCCESS_COLOR,
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _vm.sendBlock
              ? _c("div", { staticClass: "card" }, [
                  _c(
                    "div",
                    { staticClass: "card-body" },
                    [
                      _c(
                        "tabs",
                        {
                          staticClass: "tabs-default",
                          attrs: { options: { useUrlFragment: false } },
                        },
                        [
                          _c("tab", { attrs: { name: "SMS" } }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", { attrs: { for: "" } }, [
                                _vm._v("Номер телефона"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.selectedPhoneForSend,
                                      expression: "selectedPhoneForSend",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.selectedPhoneForSend = $event.target
                                        .multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                  },
                                },
                                _vm._l(_vm.phones, function (p, i) {
                                  return _c(
                                    "option",
                                    { domProps: { value: i } },
                                    [_vm._v(_vm._s(p.phone.phone))]
                                  )
                                }),
                                0
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "alert alert-info p-1" }, [
                              _c("p", [
                                _vm._v("Перенос строки не отображается в SMS"),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", { attrs: { for: "" } }, [
                                _vm._v("Сообщение"),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.smsText,
                                    expression: "smsText",
                                  },
                                ],
                                staticClass: "form-control message_input",
                                domProps: { value: _vm.smsText },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.smsText = $event.target.value
                                  },
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "text-right" },
                              [
                                _c("LoadingButton", {
                                  attrs: {
                                    title: "Отправить SMS",
                                    type: "button",
                                    loading: _vm.btnSendSMS,
                                    color: _vm.$constants.SUCCESS_COLOR,
                                    onClick: () => {
                                      _vm.sendCardNumber()
                                    },
                                    className: "btn btn-outline-success btn-xs",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.localOrder.extra_options.email
                            ? _c(
                                "tab",
                                { attrs: { name: "Email" } },
                                [
                                  _c("div", { staticClass: "mb-2" }, [
                                    _c("p", [_vm._v("Выберите тип письма")]),
                                    _vm._v(" "),
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.selectedLetter,
                                            expression: "selectedLetter",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        on: {
                                          change: [
                                            function ($event) {
                                              var $$selectedVal =
                                                Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function (o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function (o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                              _vm.selectedLetter = $event.target
                                                .multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            },
                                            _vm.updateSelectedLetter,
                                          ],
                                        },
                                      },
                                      [
                                        _c(
                                          "option",
                                          {
                                            attrs: { value: "0", disabled: "" },
                                          },
                                          [_vm._v("Выберите шаблон письма")]
                                        ),
                                        _vm._v(" "),
                                        _vm._l(_vm.letters, function (l) {
                                          return _c(
                                            "option",
                                            { domProps: { value: l.id } },
                                            [_vm._v(_vm._s(l.title))]
                                          )
                                        }),
                                      ],
                                      2
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _vm.selectedLetter && _vm.letter
                                    ? [
                                        _c("LetterEdit", {
                                          ref: "letter",
                                          attrs: {
                                            letter: _vm.letter,
                                            cards: _vm.cardsForOrder,
                                            order: {
                                              ..._vm.localOrder,
                                              paymentLink: _vm.paymentLink,
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "text-right mt-1" },
                                          [
                                            _c("LoadingButton", {
                                              attrs: {
                                                title: "Отправить письмо",
                                                className:
                                                  "btn btn-outline-success btn-xs",
                                                onClick: () => _vm.sendLetter(),
                                                loading: _vm.sendLetterBtn,
                                                color:
                                                  _vm.$constants.SUCCESS_COLOR,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.selectedSMS
              ? _c("div", { staticClass: "card" }, [
                  _c(
                    "div",
                    { staticClass: "card-body" },
                    [
                      _c("PairSMS", {
                        attrs: {
                          order: _vm.order,
                          pairedRecord: _vm.selectedSMS,
                          onAccept: _vm.prepaidConfirmed,
                          updateData: _vm.getOrderDetail,
                        },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.orderType === "selectedCard"
              ? [
                  _c("div", { staticClass: "card" }, [
                    _c(
                      "div",
                      { staticClass: "card-body" },
                      [
                        _c(
                          "div",
                          { staticClass: "flex justify-content-between" },
                          [
                            _c("div", [
                              !(_vm.pairedSMS && _vm.pairedSMS.length)
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-default btn-xs",
                                      on: { click: () => _vm.addToOrder() },
                                    },
                                    [
                                      _vm._v(
                                        "подтвердить оплату без SMS\n              "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("pulse-loader", {
                          staticClass: "text-center",
                          attrs: {
                            loading: _vm.smsLoading,
                            color: _vm.$constants.LOADING_COLOR,
                          },
                        }),
                        _vm._v(" "),
                        !_vm.smsLoading && _vm.sms.length
                          ? _c(
                              "table",
                              {
                                staticClass:
                                  "table table-sm table-hover mt-1 mb-1",
                              },
                              [
                                _vm._m(0),
                                _vm._v(" "),
                                _c(
                                  "tbody",
                                  _vm._l(_vm.sms, function (m, i) {
                                    return _c(
                                      "tr",
                                      { class: { recommend: m.recommend } },
                                      [
                                        _c("td", [_vm._v(_vm._s(i + 1))]),
                                        _vm._v(" "),
                                        _c("td", [_vm._v(_vm._s(m.id))]),
                                        _vm._v(" "),
                                        _c("td", [_vm._v(_vm._s(m.card_id))]),
                                        _vm._v(" "),
                                        _c("td", [_vm._v(_vm._s(m.sum))]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _c("div", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.formatMessage(m.message)
                                              ),
                                            },
                                          }),
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(_vm.printCustomDate(m.date))
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-outline-success btn-xs",
                                              attrs: { type: "button" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.addToOrder(m)
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "привязать к\n                  заявке\n                "
                                              ),
                                            ]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("td"),
                                      ]
                                    )
                                  }),
                                  0
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "card" }, [
                    _c("div", { staticClass: "card-body" }, [
                      !_vm.showAllSMS
                        ? _c("div", { staticClass: "text-right" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-default",
                                on: {
                                  click: function ($event) {
                                    _vm.showAllSMS = true
                                  },
                                },
                              },
                              [_vm._v("Показать все SMS")]
                            ),
                          ])
                        : _c(
                            "div",
                            { staticClass: "all_sms_records" },
                            [
                              _c("div", [
                                _c("label", [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.filter.byPhone,
                                        expression: "filter.byPhone",
                                      },
                                    ],
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      checked: Array.isArray(_vm.filter.byPhone)
                                        ? _vm._i(_vm.filter.byPhone, null) > -1
                                        : _vm.filter.byPhone,
                                    },
                                    on: {
                                      change: function ($event) {
                                        var $$a = _vm.filter.byPhone,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                _vm.filter,
                                                "byPhone",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                _vm.filter,
                                                "byPhone",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(_vm.filter, "byPhone", $$c)
                                        }
                                      },
                                    },
                                  }),
                                  _vm._v(
                                    " поиск SMS по телефону\n                " +
                                      _vm._s(_vm.filter.phoneNum) +
                                      " (привязан к карте)"
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("BankSMSList", {
                                attrs: {
                                  noSearchOrders: true,
                                  filter: _vm.filter,
                                  onPairRecord: (m) => _vm.addToOrder(m),
                                },
                              }),
                            ],
                            1
                          ),
                    ]),
                  ]),
                ]
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("ID")]),
        _vm._v(" "),
        _c("th", [_vm._v("Карта")]),
        _vm._v(" "),
        _c("th", [_vm._v("Сумма")]),
        _vm._v(" "),
        _c("th", [_vm._v("Сообщение")]),
        _vm._v(" "),
        _c("th", [_vm._v("Дата")]),
        _vm._v(" "),
        _c("th"),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }